import { render } from "./addComponent.vue?vue&type=template&id=476e46cd"
import script from "./addComponent.vue?vue&type=script&lang=js"
export * from "./addComponent.vue?vue&type=script&lang=js"

import "./addComponent.vue?vue&type=style&index=0&id=476e46cd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__